import React from 'react';

type IRectangleInfoProps = {
  isContact?: boolean;
  isActive?: boolean;
};

const RectangleInfo = ({ isContact, isActive }: IRectangleInfoProps) => {
  if (isContact) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='109'
        height='32'
        viewBox='0 0 109 32'
        fill='none'
      >
        <path
          d='M99.0679 0.5L107.58 11.8223V31.5H0.621582V0.5H99.0679Z'
          fill={isActive ? '#2D6772' : '#E4F4F6'}
          stroke={isActive ? 'unset' : '#232F3E'}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='138'
      height='32'
      viewBox='0 0 138 32'
      fill='none'
    >
      <path
        d='M126.22 0.5L137.089 11.8545V31.5H0.621521V0.5H126.22Z'
        fill={isActive ? '#2D6772' : '#E4F4F6'}
        stroke={isActive ? 'unset' : '#232F3E'}
      />
    </svg>
  );
};

export default RectangleInfo;
